<template>
    <div>
        <b-breadcrumb :items="items"/>
        <form class="container-fluid" style="background-color: white">
            <div class="row">
                <div class="col-12">
                    <h4 class="text-center pt-3 text-bold">ตั้งค่าสินค้า</h4>
                </div>
                <div class="col-4 row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        สถานะ
                    </label>
                    <div class="col-8">
                        <select class="form-control" v-model="form.status">
                            <option value="inactive">inactive</option>
                            <option value="active">active</option>
                        </select>
                    </div>
                </div>
                <div class="col-4 row">
                    <label class="col-sm-4 col-form-label text-capitalize text-right">
                        รหัสโควต้า
                    </label>
                    <div class="col-8">
                        <input class="form-control"
                               placeholder="รหัสโควต้า"
                               type="text"
                               readonly
                               v-model="form.no"/>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-4 row">
                    <label class="col-4 col-form-label text-capitalize text-right">
                        ประเภทสินค้า
                    </label>
                    <div class="col-8">
                        <multiselect placeholder="เลือกประเภทสินค้า"
                                     :customLabel="customLabelType"
                                     track-by="id"
                                     :select-label="''"
                                     :options="optionProductType"
                                     v-model="form.product_type"
                                     @input="getListProduct">
                        </multiselect>
                    </div>
                </div>
                <div class="col-4 row">
                    <label class="col-4 col-form-label text-capitalize text-right">
                        สินค้า
                    </label>
                    <div class="col-8">
                        <multiselect
                            :disabled="!form.product_type"
                            v-model="form.product"
                            :options="optionProduct"
                            :customLabel="LabelSkuWithName"
                            placeholder="ค้นหาสินค้า"
                            :show-labels="false"
                            track-by="id"
                            @input="setRealStock">
                        </multiselect>
                    </div>
                </div>
                <div class="col-4 row">
                    <label class="col-4 col-form-label text-capitalize text-right">
                        นำเข้าจริง
                    </label>
                    <div class="col-8">
                        <input class="form-control"
                               placeholder="นำเข้าจริง"
                               type="text"
                               readonly
                               v-model="form.real_stock"/>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-4 row">
                </div>
                <div class="col-4 row">
                </div>
                <div class="col-4 row">
                    <label class="col-5 col-form-label text-capitalize text-right">
                        ช่วงเวลาโควต้า
                    </label>
                    <div class="col-7">
                        <select class="form-control" v-model="form.quota_day">
                            <option value="1">1 วัน</option>
                            <option value="2">2 วัน</option>
                            <option value="3">3 วัน</option>
                            <option value="4">4 วัน</option>
                            <option value="5">5 วัน</option>
                            <option value="6">6 วัน</option>
                            <option value="7">7 วัน</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <table width="100%">
                    <thead>
                    <tr>
                        <th class="text-left pl-5" colspan="2">รายชื่อเซลล์</th>
                        <th></th>
                        <th></th>
                        <th>โควต้าพิเศษ</th>
                        <th>สรุปยอด</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(x,i) in list" :key="i">
                        <td class="text-left pl-5" v-if="editMode">{{ (x.sale.sale_id + '-' + x.sale.name) }}</td>
                        <td class="text-left pl-5" v-else>{{ (x.sale_id + '-' + x.name) }}</td>
                        <td>จำนวนที่จำกัด</td>
                        <td>
                            <input class="form-control"
                                   placeholder="จำนวนที่จำกัด"
                                   type="text"
                                   readonly
                                   v-model="x.stock"/>
                        </td>
                        <td>หน่วย</td>
                        <td>
                            <input class="form-control"
                                   placeholder="โควต้าพิเศษ"
                                   type="number"
                                   @input="calculateSumRemain"
                                   v-model="x.extra"/>
                        </td>
                        <td>
                            <span>{{ (parseInt(x.stock) + parseInt(x.extra) || 0) }}</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="row mt-2">
                <div class="col-6 row">
                    <label class="col-7 col-form-label text-capitalize text-right">
                        เศษคงเหลือ : {{ new Date().setDate(new Date().getDate() - 1) | moment("DD/MM/YYYY") }}
                    </label>
                    <div class="col-4">
                        <input class="form-control"
                               placeholder="เศษคงเหลือ"
                               type="text"
                               readonly
                               v-model="form.stock_remain_ytd"/>
                    </div>
                    <label class="col-1 col-form-label text-capitalize text-right">
                        หน่วย
                    </label>
                </div>
                <div class="col-6 row">
                    <label class="col-8 col-form-label text-capitalize text-right">
                        ยอดรวมรอหาร(เศษปัจจุบัน)
                    </label>
                    <div class="col-4">
                        <input class="form-control"
                               placeholder="เศษคงเหลือ"
                               type="text"
                               readonly
                               v-model="form.sum_remain"/>
                    </div>
                </div>

                <div class="col-6 row mt-2">
                    <label class="col-7 col-form-label text-capitalize text-right">
                        หมดอายุการจองทุกเซลล์
                    </label>
                    <div class="col-4">
                        <input class="form-control"
                               placeholder="เศษคงเหลือ"
                               type="text"
                               readonly
                               v-model="form.sum_all_sale"/>
                    </div>
                    <label class="col-1 col-form-label text-capitalize text-right">
                        หน่วย
                    </label>
                </div>
            </div>

            <template>
                <b-row class="mt-4 pb-3">
                    <div class="col text-center">
                        <button type="button" class="btn btn-success"
                                :disabled="this.form.sum_remain < 0"
                                @click="onSubmit">
                            <icon name="save" style="width: 25px"></icon>
                            บันทึก
                        </button>
                        &nbsp;&nbsp;
                        <button type="button" class="btn btn-outline-secondary">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </button>
                    </div>
                </b-row>
            </template>
        </form>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";

export default {
    name: "quota-form",
    components: {
        Multiselect
    },
    created() {
        this.$store.dispatch('Seller/getQuota').then(res => {
            this.list = res;
            this.optionProduct = this.optionProducts;
            Promise.all([
                this.$store.dispatch("Products/getProductAll"),
                this.$store.dispatch('ProductType/get')
            ]).then(() => {
                if (this.$route.params.id){
                    this.$store.dispatch('Seller/quotaShow',this.$route.params.id).then(res=>{
                        this.respone_form = res;
                        this.editMode = true;
                        this.setForm();
                    });
                }else {
                    this.$store.dispatch('Seller/generateNO').then(res => {
                        this.form.no = res
                    });
                }
            });
        });
    },
    data() {
        return {
            items: [
                {
                    text: "รายการจองโควต้า",
                    to: {name: "quota-list"}
                },
                {
                    text: "เพิ่มโควต้า",
                    active: true
                }
            ],
            form: {
                id: '',
                status: 'active',
                quota_day: 3,
                no: '',
                product_type: '',
                product: '',
                real_stock: '',
                stock_remain: 0,
                stock_remain_ytd: 0,
                sum_remain: 0,
                sum_all_sale: 0,
            },
            respone_form: {},
            list: [],
            optionProduct: [],
            editMode: false
        }
    },
    computed: {
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            optionProductType: state => {
                return [
                    {
                        value: "",
                        name: "หมวดหมู่สินค้า"
                    },
                    ...state.ProductType.data.map(type => ({
                        value: type.id,
                        name: type.name
                    }))
                ];
            },
            optionProducts: (state) => {
                return state.Products.product_all;
            }
        }),
    },
    methods: {
        customLabelType(option) {
            return `${option.name}`
        },
        LabelSkuWithName(option) {
            if (this.optionProducts.length > 0) {
                return `${option.sku} - ${option.short_name?option.short_name:''}`
            }
        },
        getListProduct() {
            this.optionProduct = this.optionProducts.filter(x => {
                return x.product_type_id == this.form.product_type.value
            })
            this.form.product = '';
        },
        calculateSumRemain(){
            if (this.form.product) {
                let per_sale = 0;
                let sum = this.list.reduce((acc, item) => acc + parseInt(item.extra), 0);
                this.form.sum_remain = ((this.form.real_stock - sum) % (this.list.length + 1)) + this.form.sum_all_sale;

                this.form.stock_remain = (this.form.real_stock - sum) % (this.list.length + 1);
                per_sale = ((this.form.real_stock - this.form.stock_remain - sum) / (this.list.length + 1) || 0);

                this.list.forEach(x => {
                    x.stock = x.sale_id == '05' ? per_sale * 2 : per_sale
                })
            }
        },
        setForm(){
            this.form.status = this.respone_form.active
            this.form.quota_day = this.respone_form.date_range
            this.form.no = this.respone_form.no
            this.form.product_type = this.respone_form.product.product_type
            this.form.product = this.respone_form.product
            this.form.real_stock = this.respone_form.real_stock
            this.form.stock_remain = this.respone_form.remain
            this.form.sum_remain = this.respone_form.remain
            this.list = this.respone_form.detail
            this.list.forEach(x=>x.stock = x.limit)
        },
        setRealStock() {
            if (this.form.product) {
                this.$store.dispatch('Seller/checkYTD',{
                    id : this.form.product.id
                }).then(res => {
                    this.form.real_stock = res.real_stock;
                    let per_sale = 0;
                    if (res == 'not found'){
                        this.form.stock_remain = (this.form.real_stock) % (this.list.length + 1);
                        per_sale = (this.form.real_stock - this.form.stock_remain) / (this.list.length + 1);
                    }else{
                        this.form.stock_remain = (this.form.real_stock + res.ytd_left + res.expire) % (this.list.length + 1);
                        per_sale = (this.form.real_stock + res.ytd_left + res.expire - this.form.stock_remain) / (this.list.length + 1);
                    }
                    this.list.forEach(x => {
                        x.stock = x.sale_id == '05' ? per_sale * 2 : per_sale
                    })

                    this.form.stock_remain_ytd = res == 'not found'?0:res.ytd_left;
                    this.form.sum_all_sale = res == 'not found'?0:res.expire;
                    this.form.sum_remain = this.form.stock_remain;
                });
            }
        },
        onSubmit() {
            this.form.updated_by = this.user.id;
            if (this.$route.params.id)
                this.form.id = this.$route.params.id;
            let data = {
                form : this.form,
                details : this.list
            }
            this.$store.dispatch('Seller/quotaSubmit',data).then(() => {
                this.$router.push('quota-list')
            });
        }
    }

}
</script>

<style scoped>
.text-bold {
    font-weight: bold;
}

thead tr {
    background-color: #ffbf00;
    color: white;
}

thead td {
    color: black;
    background-color: #ebebe0;
}
</style>
